module.exports = __webpack_public_path__ + "static/media/olu-eletu.d9bcce95.jpg";